import { Capacitor, FilesystemDirectory } from '@capacitor/core'

export default async function syncCodePush(skipInstall = false) {
    if (process.env.NODE_ENV !== 'production') {
        return
    }
    if (typeof codePush === 'undefined') {
        return
    }

    if (!skipInstall) {
        console.log('checking for code push update')
        const baseUrl = (
            await Capacitor.Plugins!.Filesystem.getUri({ path: '', directory: FilesystemDirectory.Data })
        ).uri.replace('file://', '')

        codePush.getPendingPackage((localPackage) => {
            if (localPackage) {
                const path = `${baseUrl}${localPackage.localPath}/dist`
                switchToPath(path)
            } else {
                codePush.getCurrentPackage((localPackage) => {
                    const path = `${baseUrl}${localPackage.localPath}/dist`
                    switchToPath(path)
                })
            }
        })
    }

    codePush.sync(
        function (syncStatus) {
            switch (syncStatus) {
                // Result (final) statuses
                case SyncStatus.UPDATE_INSTALLED:
                    break
                case SyncStatus.UP_TO_DATE:
                    break
                case SyncStatus.UPDATE_IGNORED:
                    break
                case SyncStatus.ERROR:
                    break

                // Intermediate (non final) statuses
                case SyncStatus.CHECKING_FOR_UPDATE:
                    console.log('Checking for update.')
                    break
                case SyncStatus.AWAITING_USER_ACTION:
                    console.log('Alerting user.')
                    break
                case SyncStatus.DOWNLOADING_PACKAGE:
                    console.log('Downloading package.')
                    break
                case SyncStatus.INSTALLING_UPDATE:
                    console.log('Installing update')
                    break
            }
        },
        {
            installMode: InstallMode.ON_NEXT_RESTART,
        },
        function (downloadProgress) {
            console.log(
                'Downloading ' + downloadProgress.receivedBytes + ' of ' + downloadProgress.totalBytes + ' bytes.'
            )
        }
    )
}

async function switchToPath(path: string) {
    if ((await Capacitor.Plugins!.WebView.getServerBasePath()).path === path) {
        return
    }

    Capacitor.Plugins!.WebView.setServerBasePath({ path })
    Capacitor.Plugins!.WebView.persistServerBasePath()
}
